export default class Favourites {
	constructor(container) {

		this.buttonElement = container;
		this.init();

		this.favouritesElement = container;
		this.favouritesElement.disabled = false;
		this.popupElement = document.querySelector('.js-popup-favourites');

		// console.log('Favourites component');
		// console.log(this.favouritesElement);

		// Match current favourite list
		let cookieValue = document.cookie.match(new RegExp('(^| )' + (customData?.cookieFavourites ?? null) + '=([^;]+)'));
		cookieValue = cookieValue ? decodeURIComponent(cookieValue[2]) : '';
		let favourites = cookieValue ? cookieValue.split(',') : [];
		let currentPageId = this.getCurrentPageId();

		// Check if page already listed
		if (favourites.indexOf(currentPageId) > -1) {
			this.favouritesElement.classList.add('active');
		}

		this.favouritesElement.addEventListener('click', () => {
			//console.log('click on the new element');
			this.toggleFavourites(favourites, currentPageId);
		});
	}

	init() {
		this.buttonElement.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
		// Handle the click event
	}

	getCurrentPageId() {
		let currentPageId = 0;
		document.body.classList.forEach((className) => {
			if (className.indexOf('postid-') > -1) {
				currentPageId = className.replace('postid-', '');
			}
		});
		return currentPageId;
	}

	toggleFavourites(favourites, currentPageId) {
		let otherElements = document.querySelectorAll('[data-itemid="' + currentPageId + '"] button');
		if (this.favouritesElement.classList.contains('active')) {
			this.changePopupVisibility(true);
			this.favouritesElement.classList.remove('active');
			otherElements.forEach((el) => { el.classList.remove('active') } );
		} else {
			this.changePopupVisibility(false);
			this.favouritesElement.classList.add('active');
			otherElements.forEach((el) => { el.classList.add('active') } );
		}
		updateCookieWishlist(favourites, currentPageId);
	}

	addDocumentClickListener() {
		this.documentClickListener = (event) => {
			if (!this.popupElement.contains(event.target) && !this.favouritesElement.contains(event.target) && !event.target.closest('.btn--favourite-outline')) {
				this.popupElement.classList.remove('open');
				this.removeDocumentClickListener();
			}
		};
		document.addEventListener('click', this.documentClickListener);
	}

	removeDocumentClickListener() {
		document.removeEventListener('click', this.documentClickListener);
	}

	changePopupVisibility(remove) {
		// Match login cookie
		let match = document.cookie.match(new RegExp('(^| )' + (customData?.cookieContactId ?? null) + '=([^;]+)'));
		match = match ? match[2] : '';
		let isLoggedIn = !!match;

		this.popupElement.querySelectorAll('.js-popup-favourites-main').forEach((el) => {
			el.classList.remove('is-visible');
		});

		if (remove) {
			this.popupElement.querySelectorAll('.js-popup-favourites-main').forEach((el) => {
				if (el.classList.contains('js-popup-favourites-remove')) {
					el.classList.add('is-visible');
				} else {
					el.classList.remove('is-visible');
				}
			});
		} else {
			this.popupElement.querySelectorAll('.js-popup-favourites-main').forEach((el) => {
				if (String(el.dataset.logged_in) == String(isLoggedIn)) {
					el.classList.add('is-visible');
				} else {
					el.classList.remove('is-visible');
				}
			});
		}

		// Open popup and close after 5 seconds
		this.popupElement.classList.add('open');
		setTimeout(() => {
			this.popupElement.classList.remove('open');
		}, 5000);

		this.addDocumentClickListener();
	}
}

export function updateCookieWishlist(favourites, addOrRemoveIds) {
	var expiryDate = new Date();
	expiryDate.setMonth(expiryDate.getMonth() + 1);
	let newValue = '';

	if ( 'string' == typeof addOrRemoveIds ) {
		addOrRemoveIds = [ addOrRemoveIds ];
	}

	for ( var i in addOrRemoveIds ) {
		let id = addOrRemoveIds[i];
		let index = favourites.indexOf(id.toString());
		let maybe_negative = favourites.indexOf((parseInt(id) * -1).toString());
		if ( index > -1 ) {
			// remove value from Array
			favourites.splice(index,1);
			// add negative value to remove from db
			if ( maybe_negative < 0 ) {
				favourites.push((parseInt(id) * -1).toString());
			}
		} else {
			// add value to Array
			favourites.push(id.toString());
			// remove potential deletes (if event gets re-added)
			if ( maybe_negative > -1 ) {
				favourites.splice(maybe_negative,1);
			}
		}
	}

	newValue = favourites.length > 0 ? favourites.join(',') : '';

	if ( newValue == '' ) {
		expiryDate = new Date();
		expiryDate.setMonth(expiryDate.getMonth() - 1);
	}

	console.log('Updating wishlist...');
	document.cookie = `${customData?.cookieFavourites}=${newValue}; expires=${expiryDate}; path=/`;
}
